export default "__VITE_ASSET__s$TZHDRW__"